module.exports = __webpack_public_path__ + "img/hk_biei.cc4493f8.png";